import * as React from 'react';

import SignatureStatusLabel from 'af-root/scenes/Company/FieldReports/Shared/SignatureStatusLabel';

import type { CertificationStatus } from '@acceligentllc/shared/enums/certificationStatus';
import { TimeSheetApprovalStatus } from '@acceligentllc/shared/enums/timeSheetApprovalStatus';
import type { TimeSheetSignatureStatus } from '@acceligentllc/shared/enums/timeSheetSignatureStatus';

import styles from './styles.module.scss';
import CertificationStatusDisplay from '../../FieldReportsList/TimeSheets/TimeSheetRow/CertificationStatusDisplay';

interface WorkShift {
	accountId: number;
	certificationStatus: Nullable<CertificationStatus>;
	certificationReason: Nullable<string>;
	/** format: ISO_DATETIME */
	outdatedAt: Nullable<string>;
	/** format: ISO_DATETIME */
	startTime: Nullable<string>;
	/** format: ISO_DATETIME */
	endTime: Nullable<string>;
}

interface OwnProps {
	fullName: string;
	approvalStatus: Nullable<TimeSheetApprovalStatus>;
	signatureStatus: TimeSheetSignatureStatus;
	workShifts: WorkShift[];
}

type Props = OwnProps;

const TimeSheet: React.FC<Props> = (props: Props) => {
	const { fullName, approvalStatus, signatureStatus, workShifts } = props;

	const status = approvalStatus !== TimeSheetApprovalStatus.PENDING
		? approvalStatus
		: signatureStatus;

	return (
		<div className={styles['status-tooltip__time-sheet']}>
			{!!status && (
				<SignatureStatusLabel
					className="work-order-status-summary__time-sheet-label"
					status={status}
				/>
			)}
			{
				workShifts.map((shift) => {
					return (
						<CertificationStatusDisplay
							key={`${shift.accountId}:${shift.startTime}-${shift.endTime}`}
							workShift={shift}
						/>
					);
				})
			}
			<div>{fullName}</div>
		</div>
	);
};

export default React.memo(TimeSheet);
